import { Reveal, Overline } from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { ArrowRight, Coins, Users, FileCheck, Handshake } from "lucide-react";
import LeadDialog from "@/components/LeadDialog";

const CEE_IMG =
  "https://images.unsplash.com/photo-1764885518069-84608997f900?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxlbmVyZ3klMjBlZmZpY2llbmN5JTIwZ3JlZW4lMjBidWlsZGluZ3xlbnwwfHx8fDE3ODM5MzQ3ODd8MA&ixlib=rb-4.1.0&q=85&w=1200";

const BLOCKS = [
  { icon: Coins, t: "Fonctionnement du dispositif", d: "Les fournisseurs d'énergie (les « obligés ») financent des travaux d'économies d'énergie en contrepartie de certificats." },
  { icon: Users, t: "Les bénéficiaires", d: "Entreprises, collectivités et gestionnaires de patrimoine réalisant des travaux éligibles." },
  { icon: FileCheck, t: "Conditions d'obtention", d: "Travaux conformes aux fiches d'opérations standardisées, réalisés par des professionnels qualifiés." },
  { icon: Handshake, t: "Montage & aides mobilisables", d: "Nous identifions les primes et bonifications et gérons l'intégralité du montage administratif." },
];

export default function CEE() {
  return (
    <section id="cee" className="bg-white py-24 lg:py-32" data-testid="cee-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <div className="relative overflow-hidden">
              <img src={CEE_IMG} alt="Bâtiment équipé de panneaux solaires" className="w-full h-[440px] object-cover hover:scale-105 transition-transform duration-700" />
              <div className="absolute bottom-0 left-0 bg-emerald text-white p-6 max-w-xs">
                <p className="font-display text-lg font-bold leading-tight">
                  Nous prenons en charge l'intégralité du dossier CEE.
                </p>
              </div>
            </div>
          </Reveal>

          <div>
            <Overline>Financement des travaux</Overline>
            <h2 className="font-display text-3xl lg:text-4xl font-bold tracking-tight text-midnight">
              Les <span className="text-brandblue">Certificats d'Économies d'Énergie</span>
            </h2>
            <p className="mt-5 text-slate-600 font-light leading-relaxed">
              Les CEE sont un puissant levier de financement de la rénovation énergétique. Ils peuvent
              couvrir une part majeure — parfois la totalité — de certains travaux, selon les dispositifs.
            </p>

            <div className="mt-8 space-y-px bg-slate-200 border border-slate-200">
              {BLOCKS.map((b, i) => (
                <Reveal key={b.t} delay={i * 0.06} className="bg-white p-6 flex gap-4">
                  <div className="h-11 w-11 bg-slate-100 flex items-center justify-center shrink-0">
                    <b.icon className="h-5 w-5 text-emerald" strokeWidth={1.5} />
                  </div>
                  <div>
                    <h3 className="font-display font-bold text-midnight">{b.t}</h3>
                    <p className="text-sm text-slate-600 font-light mt-1">{b.d}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <LeadDialog leadType="audit">
              <Button className="mt-8 rounded-none bg-emerald hover:bg-emerald-600 text-white px-8 py-6 group" data-testid="cee-cta">
                Estimer mes aides CEE <ArrowRight className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </LeadDialog>
          </div>
        </div>
      </div>
    </section>
  );
}
